var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack203({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.11,10.24l1.6-.19a1.49,1.49,0,0,0,.41.93,1.09,1.09,0,0,0,.81.32,1.15,1.15,0,0,0,.86-.38,1.53,1.53,0,0,0,.34-1.05,1.4,1.4,0,0,0-.33-1A1.06,1.06,0,0,0,8,8.53a2.89,2.89,0,0,0-.76.12l.18-1.34a1.46,1.46,0,0,0,1-.29,1,1,0,0,0,.35-.82.9.9,0,0,0-.26-.69.93.93,0,0,0-.68-.26,1,1,0,0,0-.72.29,1.43,1.43,0,0,0-.37.86L5.24,6.14A3.31,3.31,0,0,1,5.71,4.9a2.21,2.21,0,0,1,.9-.74A3.08,3.08,0,0,1,7.89,3.9a2.54,2.54,0,0,1,1.94.77,2,2,0,0,1,.6,1.43A2,2,0,0,1,9.2,7.9a2,2,0,0,1,1.62,2A2.57,2.57,0,0,1,10,11.87a2.88,2.88,0,0,1-2.06.8A2.89,2.89,0,0,1,6,12,2.68,2.68,0,0,1,5.11,10.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack203);
export default __webpack_public_path__ + "static/media/Symbolpack_2_03.9c8c3359ce77bcaa010707eafab8b5dc.svg";
export { ForwardRef as ReactComponent };